export enum OuterMessageType {
  CALL_METHOD = "crane:callMethod",
  BIND_EVENT = "crane:bindEvent",
  CHECK_API = "crane:checkAPI",
}

export enum InnerMessageType {
  DISPATCH_EVENT = "crane:dispatchEvent",
  RESOLVE_METHOD = "crane:resolveMethod",
  ACK_API = "crane:ackAPI",
}

interface OuterMessage {
  type: OuterMessageType;
  uuid: string;
}

export interface BindMessage extends OuterMessage {
  type: OuterMessageType.BIND_EVENT;
  event: string;
}

export interface CallMethodMessage extends OuterMessage {
  type: OuterMessageType.CALL_METHOD;
  method: string;
  args: any[];
}

export interface CheckApiMessage extends OuterMessage {
  type: OuterMessageType.CHECK_API;
}

export type AnyOuterMessage = BindMessage | CallMethodMessage | CheckApiMessage;

interface InnerMessage {
  type: InnerMessageType;
  uuid: string;
  data: any;
}

export interface DispatchEventMessage extends InnerMessage {
  type: InnerMessageType.DISPATCH_EVENT;
  data: any;
}

export interface ResolveMethodMessage extends InnerMessage {
  type: InnerMessageType.RESOLVE_METHOD;
  data: crane.ResponseData;
}

export interface AckApiMessage extends InnerMessage {
  type: InnerMessageType.ACK_API;
  data: jigsaw.BookData;
}

export type AnyInnerMessage =
  | DispatchEventMessage
  | ResolveMethodMessage
  | AckApiMessage;
